/** Data share invites (messages). */
const dictionary = {
  en: {
    title: "Data Share Invites",
    invitation: "Invitation",
    status: "Status",
    dataAccess: "Data access",
    team: "Team",
    job: "Role",
    about: "About",
    requestedAssessments: "Requested assessments",
    areYouEmployedBy: "Are you employed by",
    andWorkInTeam: "and work in team",
    areYouApplyingToJob: "Are you applying to position",
    inCompany: "in company",
    statusOption: {
      pending: "Pending",
      accepted: "Accepted",
      declined: "Declined",
      0: "Pending",
      1: "Pending",
      2: "Accepted",
      3: "Declined",
    },
    dialog: {
      accept: {
        header: "Share your assessment data?",
        content:
          "The company will be able to view the assessment results they requested.",
        buttonLabel: "Allow access",
        isAccepted: true,
      },
      reject: {
        header: "Stop sharing your data?",
        content:
          "The company will no longer be able to view your assessment results. You can optionally tell us why.",
        buttonLabel: "Revoke access",
        isAccepted: false,
      },
      rejectReasons: [
        { id: 1, label: "Not enough information about the position" },
        { id: 2, label: "I am not interested in this opportunity" },
        { id: 3, label: "I did not expect this invitation" },
        { id: 4, label: "Other" },
      ],
    },
  },
  de: {
    title: "Datenfreigabe-Einladungen",
    invitation: "Einladung",
    status: "Status",
    dataAccess: "Datenzugriff",
    team: "Team",
    job: "Position",
    about: "Über",
    requestedAssessments: "Angeforderte Assessments",
    areYouEmployedBy: "Sind Sie angestellt bei",
    andWorkInTeam: "und arbeiten im Team",
    areYouApplyingToJob: "Bewerben Sie sich auf die Position",
    inCompany: "im Unternehmen",
    statusOption: {
      pending: "Ausstehend",
      accepted: "Akzeptiert",
      declined: "Abgelehnt",
      0: "Ausstehend",
      1: "Ausstehend",
      2: "Akzeptiert",
      3: "Abgelehnt",
    },
    dialog: {
      accept: {
        header: "Assessment-Daten teilen?",
        content:
          "Das Unternehmen kann die angeforderten Assessment-Ergebnisse einsehen.",
        buttonLabel: "Zugriff erlauben",
        isAccepted: true,
      },
      reject: {
        header: "Datenfreigabe beenden?",
        content:
          "Das Unternehmen kann Ihre Assessment-Ergebnisse nicht mehr einsehen. Sie können uns optional den Grund mitteilen.",
        buttonLabel: "Zugriff widerrufen",
        isAccepted: false,
      },
      rejectReasons: [
        { id: 1, label: "Nicht genug Informationen zur Stelle" },
        { id: 2, label: "Ich habe kein Interesse an dieser Möglichkeit" },
        { id: 3, label: "Ich habe diese Einladung nicht erwartet" },
        { id: 4, label: "Sonstiges" },
      ],
    },
  },
  "fi": {
    "title": "Tietojen jakopyynnöt",
    "invitation": "Kutsu",
    "status": "Tila",
    "dataAccess": "Tietojen käyttö",
    "team": "Tiimi",
    "job": "Rooli",
    "about": "Tietoja",
    "requestedAssessments": "Pyydetyt arvioinnit",
    "areYouEmployedBy": "Oletko työsuhteessa yritykseen",
    "andWorkInTeam": "ja työskenteletkö tiimissä",
    "areYouApplyingToJob": "Oletko hakemassa tehtävään",
    "inCompany": "yrityksessä",
    "statusOption": {
      "0": "Odottaa",
      "1": "Odottaa",
      "2": "Hyväksytty",
      "3": "Hylätty",
      "pending": "Odottaa",
      "accepted": "Hyväksytty",
      "declined": "Hylätty"
    },
    "dialog": {
      "accept": {
        "header": "Jaetaanko arviointitietosi?",
        "content": "Yritys voi tarkastella pyytämiään arviointituloksia.",
        "buttonLabel": "Myönnä käyttöoikeus",
        "isAccepted": true
      },
      "reject": {
        "header": "Lopetetaanko tietojesi jakaminen?",
        "content": "Yritys ei voi enää nähdä arviointituloksiasi. Voit halutessasi kertoa meille, miksi.",
        "buttonLabel": "Peruuta käyttöoikeus",
        "isAccepted": false
      },
      "rejectReasons": [
        {
          "id": 1,
          "label": "Ei tarpeeksi tietoa tehtävästä"
        },
        {
          "id": 2,
          "label": "En ole kiinnostunut tästä mahdollisuudesta"
        },
        {
          "id": 3,
          "label": "En odottanut tätä kutsua"
        },
        {
          "id": 4,
          "label": "Muu"
        }
      ]
    }
  }
};

export default dictionary;
